import React from "react";
import CoordinacionView from "./pages/CoordinacionView";

export default function CoordinacionFormacion() {
  return <CoordinacionView />;
}
